import { formatLocation } from "@/util/helper";
import { cva } from "class-variance-authority";

interface TableColumn {
  header: string;
  key: string;
  render?: (value: any, key?: string, index?: number) => React.ReactNode;
}

interface TableProps {
  columns: TableColumn[];
  data: any[];
  className?: string;
  type?: string;
}

const Table = ({ columns, data, className = "", type }: TableProps) => {
  const cellStyle = cva([
    "p-4 text-neutral-light-200 font-poppinsRegular bg-neutral-dark-100 border border-neutral-dark-400 lg:bg-transparent",
  ]);
  return (
    <div className={`border-neutral-dark-400 shadow-md ${className} -pt-1`}>
      <table className="w-full text-sm text-left font-poppinsMedium rounded-xl">
        <tbody>
          {data && data.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="bg-neutral-dark-100 border border-neutral-dark-400"
              >
                {columns.map((column, columnIndex) => (
                  <td
                    key={columnIndex}
                    className={`${cellStyle()} ${
                      ((type == "level" && columnIndex == 1) ||
                        columnIndex == 0) &&
                      "sticky -left-1 "
                    }`}
                  >
                    {column.key === "city" ? (
                      <a
                        href={formatLocation(row.city)}
                        className="capitalize text-neutral-light-200"
                      >
                        {column.render
                          ? column.render(row[column.key], column.key)
                          : row[column.key]
                              ?.split(", ")
                              .slice(0, -1)
                              .join(", ")}
                      </a>
                    ) : column.render ? (
                      column.render(row[column.key], column.key, columnIndex)
                    ) : (
                      row[column.key]
                    )}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center p-6 text-neutral-light-400 font-poppinsMedium"
              >
                No results found
              </td>
            </tr>
          )}
        </tbody>
        <thead className="bg-neutral-dark-300 text-neutral-light-500 font-poppinsMedium text-sm sticky -top-1">
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                scope="col"
                className={`p-4 border border-neutral-dark-400 ${
                  ((type == "level" && index == 1) || index == 0) &&
                  "sticky -top-1 lg:top-0 left-0 z-50 lg:relative bg-neutral-dark-300 border"
                } ${
                  column.header === "City" ? "w-[200px] lg:w-[320px]" : "w-auto"
                }`}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default Table;
